import { LogOut, Save, Settings } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { accountLabel } from '../lib/users';
import { confirmDialog } from '../stores/dialogs';
import { useSession } from '../stores/session';
import { AccountDialog } from './AccountDialog';
import { Avatar } from './ui/Avatar';
import { Menu, MenuContent, MenuItem, MenuSeparator, MenuTrigger } from './ui/Menu';

export function UserMenu() {
  const user = useSession((s) => s.user);
  const logout = useSession((s) => s.logout);
  const navigate = useNavigate();
  const [accountOpen, setAccountOpen] = useState(false);
  if (!user) return null;

  async function signOut() {
    // A guest has no password, so signing out is the end of that account.
    if (user?.isGuest) {
      const ok = await confirmDialog({
        title: 'Sign out of your guest account?',
        message:
          'Guests can’t sign back in. To keep your boards, save your account with a username and password first.',
        confirmLabel: 'Sign out anyway',
        tone: 'danger',
      });
      if (!ok) return;
    }
    await logout();
    navigate('/login', { replace: true });
  }

  return (
    <>
      <Menu>
        <MenuTrigger
          className="focus-ring rounded-full"
          aria-label={`Account menu for ${user.name}`}
        >
          <Avatar name={user.name} color={user.color} size="md" />
        </MenuTrigger>
        <MenuContent className="w-64">
          <div className="flex items-center gap-3 px-2.5 py-2">
            <Avatar name={user.name} color={user.color} size="md" />
            <div className="min-w-0">
              <p className="truncate text-sm font-medium">{user.name}</p>
              <p className="truncate text-xs text-slate-500">{accountLabel(user)}</p>
            </div>
          </div>
          <MenuSeparator />
          {user.isGuest && (
            <MenuItem icon={<Save />} onSelect={() => setAccountOpen(true)}>
              Save your account
            </MenuItem>
          )}
          <MenuItem icon={<Settings />} onSelect={() => setAccountOpen(true)}>
            Account settings
          </MenuItem>
          <MenuItem icon={<LogOut />} onSelect={() => void signOut()}>
            Sign out
          </MenuItem>
        </MenuContent>
      </Menu>
      <AccountDialog open={accountOpen} onOpenChange={setAccountOpen} />
    </>
  );
}
